// StateWrapper.js
import { useAuth } from "../Auth/AuthContext";
import { StateProvider } from ".";

const StateWrapper = ({ reducer, initialState, children }) => {
  const authContext = useAuth(); // Now this is safe because you're inside AuthProvider

  return (
    <StateProvider
      reducer={reducer}
      initialState={initialState}
      authContext={authContext} // Pass the context as a prop
    >
      {children}
    </StateProvider>
  );
};

export default StateWrapper;
